import { useCpSummary } from 'components/common-form/sidePanel/docToolbar/summary/hooks/useCpSummary';
import type { CpSummaryMailRequest } from 'components/common-form/sidePanel/docToolbar/summary/models/cpSummaryMailRequest';
import {
  SecondarySummaryBlock,
  SummaryFieldRowSecondary,
} from 'components/common-form/sidePanel/docToolbar/summary/ShareButtonSecondary';
import { FC } from 'react';

interface OrderSecondarySummaryModalProps {
  tabId: string;
  summary?: string;
}

export const OrderSecondarySummaryModal: FC<OrderSecondarySummaryModalProps> = ({ tabId, summary }) => {
  //CP Order
  const cpSummaryMailRequest: CpSummaryMailRequest = useCpSummary(tabId);

  return (
    <>
      <SecondarySummaryBlock title="Order">
        <SummaryFieldRowSecondary labelKey="orderId">{cpSummaryMailRequest.cpOrderId}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary>
          <span>{summary ?? null}</span>
        </SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
      <SecondarySummaryBlock title="Client">
        <SummaryFieldRowSecondary labelKey="client">{cpSummaryMailRequest.cpClient}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="custodian">{cpSummaryMailRequest.cpCustodian}</SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
      <SecondarySummaryBlock title="Product">
        <SummaryFieldRowSecondary labelKey="isin">{cpSummaryMailRequest.cpIsin}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="fileCode">{cpSummaryMailRequest.cpFileCode}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="ric">{cpSummaryMailRequest.cpRic}</SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
      <SecondarySummaryBlock title="Trade information">
        <SummaryFieldRowSecondary labelKey="quantity">{cpSummaryMailRequest.cpQuantity}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary
          labelKey={cpSummaryMailRequest.cpSettlementUnit === 'Quantity' ? 'cpCashAmountWithQuantity' : 'cpCashAmount'}
        >
          {cpSummaryMailRequest.cpCashAmount}
        </SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="tradeWay">{cpSummaryMailRequest.cpTradeWay}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="settlementUnit">
          {cpSummaryMailRequest.cpSettlementUnit}
        </SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
      <SecondarySummaryBlock title="Dates">
        <SummaryFieldRowSecondary labelKey="tradeDate">{cpSummaryMailRequest.cpTradeDate} </SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="settlementDate">
          {cpSummaryMailRequest.cpSettlementDate}
        </SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="cobDate">{cpSummaryMailRequest.cpCobDate}</SummaryFieldRowSecondary>
        <SummaryFieldRowSecondary labelKey="valuationDate">
          {cpSummaryMailRequest.cpValuationDate}
        </SummaryFieldRowSecondary>
      </SecondarySummaryBlock>
    </>
  );
};

OrderSecondarySummaryModal.displayName = 'OrderSecondarySummaryModal';
